export const AUTH_PERSISTENT_KEYS = {
  TOKEN: 'sdkjfdg2g8',
  USER: 'cxvxnmcvbw',
  EXPIRES_AT: '23rkhjwegr723', // optional – if you store expiry timestamps
}
